import type { InternalAxiosRequestConfig } from "axios";

export const increaseImportApiTimeout = (config: InternalAxiosRequestConfig) => {
  if (config.url?.indexOf("/import/") !== -1) {
    config.timeout = 1000 * 180;
  }

  return config;
};